<div class="flex items-center gap-2">
    <span
        class="text-label text-surface-400 cursor-default select-none"
        (click)="onVersionClick()"
        title="">
        v{{ appVersion }}
    </span>
    @if (!isProduction()) {
        <span class="text-label text-amber-500 font-medium">&bull; {{ environmentName }}</span>
    }
</div>

<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [style]="{ width: '560px' }"
    [draggable]="false"
    [resizable]="false">
    <ng-template pTemplate="header">
        <div class="flex items-center justify-between w-full gap-4">
            <span class="font-semibold text-base">App Debug Info</span>
            <div class="flex items-center gap-2">
                <p-button
                    label="Copy"
                    icon="pi pi-copy"
                    severity="secondary"
                    size="small"
                    [outlined]="true"
                    (onClick)="copyDebugInfo()"
                    ariaLabel="Copy debug info to clipboard" />
                <p-button
                    label="Clear Cache"
                    icon="pi pi-trash"
                    severity="danger"
                    size="small"
                    [outlined]="true"
                    [loading]="clearingCache"
                    (onClick)="onClearCache()"
                    ariaLabel="Clear Laravel cache" />
            </div>
        </div>
    </ng-template>
    <div class="flex flex-col gap-4 text-sm max-h-[65vh] overflow-y-auto pr-1">
        <!-- Configuration -->
        <div class="flex flex-col gap-2">
            <p class="m-0 eyebrow">
                Configuration
            </p>
            <div class="rounded-lg bg-surface-50 border border-surface-200 overflow-hidden">
                @for (
                    entry of [
                        { key: 'Version', value: appConfig.version ?? '—' },
                        { key: 'Environment', value: appConfig.environmentName },
                        {
                            key: 'Client',
                            value: appConfig.clientName + ' (' + appConfig.clientCode + ')'
                        },
                        { key: 'API URL', value: appConfig.apiEndpointURL },
                        { key: 'Production', value: appConfig.production ? 'Yes' : 'No' }
                    ];
                    track entry.key
                ) {
                    <div
                        class="flex items-start gap-3 px-3 py-2 border-b border-surface-100 last:border-0">
                        <span class="text-label text-surface-400 w-24 flex-shrink-0 pt-px">
                            {{ entry.key }}
                        </span>
                        <span class="text-label font-mono text-surface-700 break-all">
                            {{ entry.value }}
                        </span>
                    </div>
                }
            </div>
        </div>

        <!-- Feature Flags -->
        @if (appSettings.features) {
            <div class="flex flex-col gap-2">
                <p class="m-0 eyebrow">
                    Feature Flags
                </p>
                <div class="rounded-lg bg-surface-50 border border-surface-200 overflow-hidden">
                    @for (entry of $any(appSettings!.features) | keyvalue; track entry.key) {
                        <div
                            class="flex items-center justify-between px-3 py-2 border-b border-surface-100 last:border-0">
                            <span class="text-label font-mono text-surface-700">{{ entry.key }}</span>
                            <span
                                class="text-label font-semibold px-2 py-0.5 rounded-full"
                                [class.bg-green-100]="entry.value === true"
                                [class.text-green-700]="entry.value === true"
                                [class.bg-surface-100]="entry.value !== true"
                                [class.text-surface-400]="entry.value !== true">
                                {{ entry.value === true ? 'ON' : 'OFF' }}
                            </span>
                        </div>
                    }
                </div>
            </div>
        }

        <!-- Settings — grouped by parent category -->
        @for (group of settingGroups; track group.name) {
            <div class="flex flex-col gap-2">
                <p class="m-0 eyebrow">
                    {{ group.label }}
                </p>
                <div class="rounded-lg bg-surface-50 border border-surface-200 overflow-hidden">
                    @for (entry of group.entries; track entry.key) {
                        <div
                            class="flex items-center justify-between px-3 py-2 border-b border-surface-100 last:border-0">
                            <span class="text-label font-mono text-surface-700">{{ entry.key }}</span>
                            @if (entry.value === true || entry.value === false) {
                                <span
                                    class="text-label font-semibold px-2 py-0.5 rounded-full"
                                    [class.bg-green-100]="entry.value === true"
                                    [class.text-green-700]="entry.value === true"
                                    [class.bg-surface-100]="entry.value !== true"
                                    [class.text-surface-400]="entry.value !== true">
                                    {{ entry.value === true ? 'ON' : 'OFF' }}
                                </span>
                            } @else {
                                <span class="text-label font-mono text-surface-500">
                                    {{ entry.value ?? '—' }}
                                </span>
                            }
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</p-dialog>
